import React from "react";

// import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
// import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import { Menu, MenuItem, MenuItemProps, MenuProps } from "@mui/material";
import { useRoleGuardHook } from "hooks";

import { RoleName } from "../../../constants";

interface Props extends MenuProps {
  onComment?: () => void;
  onDuplicate?: () => void;
  onShare?: () => void;
  onMultiShare?: () => void;
  onDelete?: () => void;
  onEdit?: () => void;
}
export const SectionContextMenu: React.FC<Props> = (props) => {
  const {
    // onComment,
    // onDuplicate,
    onShare,
    // onMultiShare,
    onEdit,
    onDelete,
    ...menuProps
  } = props;

  const menuItemsProps: MenuItemProps["sx"] = {
    display: "flex",
    gap: "10px",
    "&:hover": {
      backgroundColor: "#EDF1F9",
      transition: "background-color 0.2s ease"
    }
  };

  // const onDuplicateRole = useRoleGuardHook(onDuplicate, [RoleName.Admin, RoleName.Analyst]);
  const onShareRole = useRoleGuardHook(onShare, [RoleName.Admin, RoleName.Analyst]);
  // const onMultiShareRole = useRoleGuardHook(onMultiShare, [RoleName.Admin, RoleName.Analyst]);
  const onDeleteRole = useRoleGuardHook(onDelete, [RoleName.Admin, RoleName.Analyst]);
  const onEditRole = onEdit && useRoleGuardHook(onEdit, [RoleName.Admin, RoleName.Analyst]);

  return (
    <Menu {...menuProps}>
      {/* <MenuItem sx={menuItemsProps} onClick={onComment}>
        <ChatOutlinedIcon /> Comment
      </MenuItem> */}
      {/* {onDuplicateRole && (
        <MenuItem sx={menuItemsProps} onClick={onDuplicateRole}>
          <ContentCopyOutlinedIcon /> Duplicate
        </MenuItem>
      )} */}
      {onShareRole && (
        <MenuItem sx={menuItemsProps} onClick={onShareRole}>
          <PersonAddOutlinedIcon /> Share
        </MenuItem>
      )}
      {/* {onMultiShareRole && <MenuItem onClick={onMultiShareRole}>Multiple Share</MenuItem>} */}
      {onEditRole && (
        <MenuItem sx={menuItemsProps} onClick={onEditRole}>
          <EditOutlinedIcon /> Edit
        </MenuItem>
      )}
      {onDeleteRole && (
        <MenuItem sx={menuItemsProps} onClick={onDeleteRole}>
          <DeleteOutlineIcon /> Delete
        </MenuItem>
      )}
    </Menu>
  );
};
